import { render, staticRenderFns } from "./updatelog.vue?vue&type=template&id=4477b636&scoped=true"
import script from "./updatelog.vue?vue&type=script&lang=ts"
export * from "./updatelog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477b636",
  null
  
)

export default component.exports